export const isEditMode = () => {
  return window.location.search === "?edit";
};
